<div class="row w-100 text-right">
    <div class="card-inline margin-right-medium">
        <button (click)="excludeCero()" mat-flat-button color="primary">Excluir con valor cero</button>
    </div>
    <div class="card-inline">
        <button (click)="excludeSelected()" mat-flat-button color="primary">Excluir seleccionadas</button>
    </div>
</div>
<div class="card-content margin-botton-medium">
    <p-scrollPanel styleClass="scroll-panel">
        <table class="search-table" mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="Select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="Date">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Fecha
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.Date | date:'dd/MM/yyyy' }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="PatientFullName">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Paciente
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.PatientFullName }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="Protocol">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Protocolo
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.Protocol }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="PracticeName">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Práctica
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.PracticeName }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="MedicalFeeAmount">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Importe
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.MedicalFeeAmount }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="Amount">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Cantidad
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.Amount }}</div>
                </td>
            </ng-container>
            <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </p-scrollPanel>
    <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
</div>